module.exports = __webpack_public_path__ + "img/bhim-logo.9267900.jpg";